import * as React from 'react';

import Helmet from 'react-helmet';

import { Footer, Header } from 'common/components';
import Routes from '../Routes';
import { WhitelabelContainer } from '../index';

import logo from 'assets/img/msc.png';

class MSCCruises extends WhitelabelContainer {
  getContent = () => {
    return (
      <>
        <Helmet>
          <meta name="robots" content="noindex, nofollow" />
        </Helmet>
        <Header logo={logo} />
        <Routes />
        <Footer />
      </>
    );
  };

  componentDidMount() {
    console.log('Mandator: MSC Cruises');
  }
}

export default MSCCruises;
